var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: {
      loaded: _vm.loaded
    }
  }, [_c('loading-overlay', {
    attrs: {
      "tracking": {
        class: 'contact'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _vm._m(0)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "pt-16 sm-md:pt-32 contact--section effect--fade-slide-in pb-44"
  }, [_c('div', {
    staticClass: "section--container section--container-page"
  }, [_c('div', {
    staticClass: "container max-w-2xl section--content"
  }, [_c('h1', [_vm._v("State Licenses")]), _vm._v(" "), _c('hr', {
    staticClass: "my-10"
  }), _vm._v(" "), _c('h2', [_vm._v("NMLS #2341556")]), _vm._v(" "), _c('div', {
    staticClass: "mt-12"
  }, [_c('h3', [_vm._v("California")]), _vm._v(" "), _c('p', {
    staticClass: "text-lg my-6"
  }, [_vm._v("DFPI Debt Collection License No. 11393-99")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-12"
  }, [_c('h3', [_vm._v("New Mexico")]), _vm._v(" "), _c('p', {
    staticClass: "text-lg my-6"
  }, [_vm._v("\n\t\t\t\t\t\tNew Mexico Small Loan Company License\n\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "href": "https://s3.extra.app/legal/SL_LIC_02451.pdf",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNo. 02451\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('ul', {
    staticClass: "pl-8 space-y-6"
  }, [_c('li', [_c('a', {
    staticClass: "text-lg btn-arrow",
    attrs: {
      "href": "https://s3.extra.app/legal/NM-Consumer-Information-Common-Terms-and-Definitions.pdf",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("NM Consumer Information - Common Terms and Definitions")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-lg btn-arrow",
    attrs: {
      "href": "https://s3.extra.app/legal/NM-Rule-of-78s-Guidelines.pdf",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("NM Rule of 78s Interest Calculation")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-12"
  }, [_c('h3', [_vm._v("North Dakota")]), _vm._v(" "), _c('p', {
    staticClass: "text-lg my-6"
  }, [_vm._v("Money Broker License No. MB104708")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-12"
  }, [_c('h3', [_vm._v("Oregon")]), _vm._v(" "), _c('p', {
    staticClass: "text-lg my-6"
  }, [_vm._v("Consumer Finance License No. 2341556")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-12"
  }, [_c('h3', [_vm._v("Pennsylvania")]), _vm._v(" "), _c('p', {
    staticClass: "text-lg my-6"
  }, [_vm._v("\n\t\t\t\t\t\tConsumer Discount License\n\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "href": "https://s3.extra.app/legal/PA_License_Certificate_106377.pdf",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNo. 106377\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-12"
  }, [_c('h3', [_vm._v("Vermont")]), _vm._v(" "), _c('p', {
    staticClass: "text-lg my-6"
  }, [_vm._v("Loan Solicitation License No. LSO-2341556")])])])])]);
}];
export { render, staticRenderFns };